/**
 * Фильтр категории разговора полосы потока — на том же триггере, что
 * «Проекты» (`FilterTrigger`, #2315): значок, подпись, шеврон, одна высота.
 * Выбор одиночный, поэтому пункты — радиогруппа меню.
 */
import { useTranslation } from 'react-i18next';
import { Tag } from 'lucide-react';
import { ANALYZED_CALL_CATEGORIES } from '@aica/api-types/schemas';
import { FilterTrigger } from '@/components/filters/FilterTrigger';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { ALL_CATEGORIES, type StreamSearch } from './useStreamWindow';

interface CallCategoryFilterProps {
  value: string;
  onChange: (category: StreamSearch['category']) => void;
  className?: string;
}

export function CallCategoryFilter({
  value,
  onChange,
  className,
}: CallCategoryFilterProps) {
  const { t } = useTranslation(['dashboard', 'records']);
  const options = [
    { value: ALL_CATEGORIES, label: t('records:records.callCategory.allCategories') },
    ...ANALYZED_CALL_CATEGORIES.map((category) => ({
      value: category,
      label: t(`records:records.callCategory.${category}`),
    })),
  ];
  const current = options.find((option) => option.value === value) ?? options[0]!;
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <FilterTrigger
          className={className}
          aria-label={`${t('objectionsPage.filters.category')}: ${current.label}`}
          icon={<Tag className="h-4 w-4" />}
          label={current.label}
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="min-w-[220px]">
        <DropdownMenuRadioGroup
          value={current.value}
          onValueChange={(next) =>
            onChange(ANALYZED_CALL_CATEGORIES.find((category) => category === next))
          }
        >
          {options.map((option) => (
            <DropdownMenuRadioItem key={option.value} value={option.value}>
              {option.label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
